import { render, staticRenderFns } from "./RemoveDrawer.vue?vue&type=template&id=19e079e6&scoped=true"
import script from "./RemoveDrawer.vue?vue&type=script&lang=js"
export * from "./RemoveDrawer.vue?vue&type=script&lang=js"
import style0 from "./RemoveDrawer.vue?vue&type=style&index=0&id=19e079e6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e079e6",
  null
  
)

export default component.exports